// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__D_Yvj","left":"InfoRow_left__1z_iQ"};